import './styles.css'
import { LaunchCommandCenter } from './ui/app'

const root = document.getElementById('app')
if (!root) throw new Error('Missing #app root')

const app = new LaunchCommandCenter(root)
void app.mount()

declare global {
  interface Window {
    trevahhhApp?: LaunchCommandCenter
  }
}

window.trevahhhApp = app
